module.exports = __webpack_public_path__ + "img/KN.c16a12ff.png";